export enum AccessLevel {
  Owner = "owner",
  User = "user",
  PowerBi = "power_bi",
}
